module.exports = __webpack_public_path__ + "img/ic_banner_arrow_prev.3717bc0e.svg";